<template>
    <v-app>
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>{{ isRegister ? stateObj.register.name : stateObj.login.name }}
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <form ref="form" @submit.prevent="isRegister ? registerMe() : login()">
                                    <v-text-field v-if="isRegister" v-model="user.full_name" name="full_name"
                                        label="Nombre Completo" type="text" prepend-icon="mdi-card-account-details"
                                        placeholder="Nombre completo" required>
                                    </v-text-field>

                                    <v-text-field v-model="user.username" name="username" label="Username" type="text"
                                        prepend-icon="mdi-account" placeholder="username" required></v-text-field>

                                    <v-text-field v-model="user.password" name="password" label="Password"
                                        type="password" prepend-icon="mdi-lock" placeholder="password" required>
                                    </v-text-field>

                                    <v-text-field v-if="isRegister" v-model="confirmPassword" name="confirmPassword"
                                        label="Confirmar la contraseña" type="password" placeholder="Repite el Password"
                                        required></v-text-field>

                                    <div class="red--text">{{ errorMessage }}</div>

                                    <v-btn type="submit" class="mt-4" color="primary" value="log in">{{ isRegister ?
                                            stateObj.register.name : stateObj.login.name
                                    }}</v-btn>

                                    <div class="mt-4" v-on:click="isRegister = !isRegister;">
                                        {{ toggleMessage }}
                                    </div>
                                </form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
    name: "Login",
    data() {
        return {
            confirmPassword: "",
            isRegister: false,
            errorMessage: "",
            user: {
                username: '',
                full_name: '',
                password: '',
            },
            stateObj: {
                register: {
                    name: 'Registrarse',
                    message: 'Ya tienes una cuenta? Entra.'
                },
                login: {
                    name: 'Login',
                    message: 'Registrarse'
                }
            }
        };
    },
    created() {
        this.getMessage();
    },
    methods: {
        ...mapActions(['logIn', 'register']),
        async login() {
            this.errorMessage = "";
            try {
                const User = new FormData();
                User.append('username', this.user.username);
                User.append('password', this.user.password);
                await this.logIn(User);
                this.$router.push('/home');
            } catch (error) {
                this.errorMessage = "Incorrect username or password."
            }
        },
        async registerMe() {
            try {
                this.errorMessage = "";

                if (this.user.password == this.confirmPassword) {
                    this.isRegister = false;
                    await this.register(this.user);
                    this.$router.push('/home');
                } else {
                    this.errorMessage = "Las contraseñas no coinciden"
                }
            } catch (error) {
                this.errorMessage = error.response.data.detail
            }
        },
        getMessage() {
            axios.get('/api/')
                .then((res) => {
                    console.log(res.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    },
    computed: {
        toggleMessage: function () {
            return this.isRegister ? this.stateObj.register.message : this.stateObj.login.message
        },
        isLoggedIn: function () {
            return this.$store.getters.isAuthenticated;
        }
    }
};
</script>